import Axios from "axios";

const API_ENDPOINT = `https://api.ufobet788.com`;

export const HTTP = Axios.create({
  baseURL: API_ENDPOINT,
});
